import { render, staticRenderFns } from "./SurveyRating.vue?vue&type=template&id=6cdca66e&"
import script from "./SurveyRating.vue?vue&type=script&lang=js&"
export * from "./SurveyRating.vue?vue&type=script&lang=js&"
import style0 from "./SurveyRating.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VRating } from 'vuetify/lib/components/VRating';
installComponents(component, {VCard,VRating})
